import { render, staticRenderFns } from "./LabelButtonModal.vue?vue&type=template&id=36113c4e"
import script from "./LabelButtonModal.vue?vue&type=script&lang=js"
export * from "./LabelButtonModal.vue?vue&type=script&lang=js"
import style0 from "./LabelButtonModal.vue?vue&type=style&index=0&id=36113c4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports